import './Contact.css'
import emailjs from 'emailjs-com'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './Header'
import Footer from './Footer'
import { useEffect, useState } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { login } from './utility';

function Contact() {
    const [userAuth, setUserAuth] = useState([])
    useEffect(() => {

        onAuthStateChanged(auth, user => {
            if (user) {

                setUserAuth(user)
            } else {
                setUserAuth(null)
            }
        })

    }, [])

    const loginUser = () => login(userAuth)

    const logout = () => {
        // setImgClick(false)
        return signOut(auth)
    }

    const emailSuccess = () => toast.success("Email successfully sent");
    const emailFailed = () => toast.error("Failed to send email");

    const sendEmail = (e) => {
        e.preventDefault()
        let { email, name, subject, message } = e.target
        // let regex = /\S/g
        if (email.value && name.value && subject.value && message.value) {

            emailjs.sendForm('service_9czeaiw', 'template_8x05a59', e.target, 'i9u5o24K-Nn8SQ2Tf')
                .then(function (response) {
                    console.log('SUCCESS!', response.status, response.text);
                    emailSuccess()
                }, function (error) {
                    emailFailed()
                    console.log('FAILED...', error);
                });
        } else {
            emailFailed()
        }
        // e.target.reset()
    }

    return (
        <>
            <div className="contact_page">
                <Header className="contact_header" user={userAuth} login={loginUser} logout={logout} />
                <main className="contact_main">
                    <ToastContainer />
                    <div className="mainText">
                        Love to hear from you, <br />
                        Get in touch 👋
                    </div>
                    <form onSubmit={sendEmail} className="contact_form">
                        <div className="input_div">
                            <div className="input_name">
                                <label>
                                    Your name
                                </label>
                                <input type="text" name="name" required />
                            </div>
                            <div className="input_email">
                                <label>Your email</label>
                                <input type="email" name="email" required />
                            </div>
                        </div>
                        <div className="subject">
                            <label>Subject</label>
                            <input type="text" name="subject" required />
                        </div>
                        <label>Message</label>
                        <textarea name='message' required />
                        <button className='emailbtn'>Send Email</button>
                    </form>
                </main>

            </div >
            <Footer user={userAuth} login={loginUser} logout={logout} />
        </>

    )
}

export default Contact